<template>
</template>

<script>
export default {
  name: "CurationFilterNoneLayout",
  mixins: [],
  components: {
  },
  inject: [],
  provide() {
    return{

    }
  },
  props: {
  },
  data() {
    return{
    }
  },
  beforeRouterEnter() {},
  created() {
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {},
  computed: {
  },
  methods:{
  },
  watch: {

  },
}
</script>

<style scoped>

</style>
